export default function PHP_jddayofweek() {
  return (
    <div>
      <h1>PHP_jddayofweek</h1>
    </div>
  );
}
